import { openModal, IModalProps, IModalOptions } from 'Helpers/modal';
import ModalLogin from './ModalLogin.vue';

export { ModalLogin };
export default ModalLogin;

export function openModalLogin(props?: IModalProps, options?: IModalOptions | false): Promise<unknown> {
  return openModal(ModalLogin, props, options);
}
